export default __webpack_public_path__ + "static/whatsApp-cd6a8ac73f7ce6196c153ad1c5ea5e5a.svg";